export default "__VITE_ASSET__Cdno5Tkg__"